
let tracker =
{
    trackScreenview: (screenName) => {
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'screen_view',
                screen_title: screenName,
                screen_location:"tarjousohjelma"
            });
        }    
    },
    trackEvent: (category, event) => {
        if (window.dataLayer) {
            window.dataLayer.push({
                event: event,
                category: category
            });
        }   
    },
    trackException: (exception) => {
        let errorAsString = errorToString(exception);
        console.log(errorAsString);
    },
    trackTiming: (category, event, time) => {
        if (window.dataLayer) {
            window.dataLayer.push({
                event:'timing_complete',
                category: category,
                value: parseInt(time, 10),
                label: event
            });
        }      
    }
};
export default tracker;

let errorToString = (error) => {
    if (error instanceof String) return error;
    else return error.message + error.stack;
}

